// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Messages_wrapper__K0ECT"};